import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as2007',
    ecrans: ['00-2'],
    params:['?stamnetab',
            '?vaesegdec',
            '?sutcleint']
});
